/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

const CustomClaimOriginalUnit = React.memo((props) => {
  const { value, data } = props;
  const RedColor = '#a81f00';

  return (
    <span
      className={data?.isBottomRow ? 'semiBoldText' : ''}
      style={{
        color: value !== null && parseFloat(value) < 0 ? RedColor : '#000',
        fontWeight: value !== null && parseFloat(value) < 0 ? 600 : 400,
      }}
    >
      {value !== null
        ? parseFloat(value) < 0
          ? `(${(parseFloat(value) * -1).toFixed(4)})`
          : value
        : ''}
    </span>
  );
});

export default CustomClaimOriginalUnit;
